import { Block, BlockFooter, Link, LoginScreenTitle, Page } from "framework7-react";

import { SignInForm } from "@/components/SignInForm";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { usePageReady } from "@/hooks/usePageReady";

export const AuthSignInPage = createPage("AuthSignInPage", PageComponent);

function PageComponent({ pageName }: PageComponentProps) {
  const { getPageProps } = usePageReady(pageName);

  return (
    <Page
      loginScreen
      noNavbar
      noSwipeback
      noToolbar
      data-component={pageName}
      {...getPageProps()}
    >
      <LoginScreenTitle>ログイン</LoginScreenTitle>
      <SignInForm />
      <Block>
        <BlockFooter>
          アカウントをお持ちでない場合 &nbsp;
          <Link href="/sign-up/">登録はこちら</Link>
        </BlockFooter>
        <BlockFooter>
          パスワードを忘れた場合 &nbsp;
          <Link href="/password-reset/">再登録はこちら</Link>
        </BlockFooter>
      </Block>
    </Page>
  );
}
